import * as React from 'react';
import PageHeader from '../PageHeader/PageHeader';
import PageLayout from '../PageLayout';
import PageStatus from '../PageStatus/PageStatus';

interface Props {
    pageTitle: string;
    showError: boolean;
    showLoading: boolean;
    children: React.ReactElement;
}

export default function PageMain({ pageTitle, showError, showLoading, children }: Props) {
    React.useEffect(() => {
        document.title = `StayInContact | ${pageTitle}`;
    }, [pageTitle]);

    return (
        <PageLayout>
            <div className="pageMain">
                <header className="pageMain__header">
                    <PageHeader title={pageTitle} />
                </header>
                <main className="pageMain__main">
                    <PageStatus showError={showError} showLoading={showLoading}>
                        <>{children}</>
                    </PageStatus>
                </main>
            </div>
        </PageLayout>
    );
}
